var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPasswordsee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9638 6.50291C18.2035 2.55251 14.2926 0 9.99941 0C5.70626 0 1.79528 2.55251 0.0361584 6.50291C-0.0120528 6.61089 -0.0120528 6.73549 0.0361584 6.84348C1.79293 10.7868 5.70274 13.3333 9.99941 13.3333C14.2949 13.3333 18.2059 10.7868 19.9638 6.84348C20.0121 6.73549 20.0121 6.61089 19.9638 6.50291ZM9.99941 12.5039C6.08843 12.5039 2.52433 10.2207 0.86398 6.6726C2.52668 3.11736 6.09078 0.830663 9.99941 0.830663C13.908 0.830663 17.471 3.11736 19.1348 6.6726C17.4745 10.2207 13.9092 12.5039 9.99941 12.5039Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99941 3.39268C8.21089 3.39268 6.75515 4.86176 6.75515 6.66668C6.75515 8.47159 8.21089 9.94068 9.99941 9.94068C11.7879 9.94068 13.2437 8.47278 13.2437 6.66668C13.2437 4.86058 11.7879 3.39268 9.99941 3.39268ZM9.99941 9.11001C8.66479 9.11001 7.57827 8.01354 7.57827 6.66549C7.57827 5.31744 8.66479 4.22215 9.99941 4.22215C11.334 4.22215 12.4217 5.31863 12.4217 6.66549C12.4217 8.01235 11.334 9.11001 9.99941 9.11001Z",
    fill: "#1A1A1A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordsee);
export default __webpack_public_path__ + "static/media/passwordsee.546aa04b7d3f39d96d6b2b6650bbf03e.svg";
export { ForwardRef as ReactComponent };